exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".items-link{color:#23c0d2}", "", {"version":3,"sources":["/var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/payment/add-adjustment/add-adjustment.component.css"],"names":[],"mappings":"AACA,YACE,aAAe,CAChB","file":"add-adjustment.component.css","sourcesContent":["\n.items-link {\n  color: #23C0D2;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/payment/add-adjustment/add-adjustment.component.css
// module id = Evt2
// module chunks = 0